import React, { useContext } from "react";
import changePasswordOrPinPageStyle from "../../assets/jss/xrs/views/changePasswordOrPinPageStyle";
import { makeStyles } from "tss-react/mui";
import landingPageStyle from "assets/jss/xrs/views/landingPageStyle.js";
import HeaderSectionLoggedID from "../SectionsPage/Sections/HeaderSectionLoggedID.js";
import ChangePasswordSection from "./ChangePasswordOrPin.js";
import Context from "../../utils/context";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
const isMobile =
  /Mobi|Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent) ||
  window.matchMedia("(max-width: 768px)").matches;
import { primaryColor } from "assets/jss/xrs.js";
import { Box } from "@mui/material";

const useStyles = makeStyles()(() => landingPageStyle);
let drawerWidth = 150;
if (isMobile) {
  drawerWidth = 0;
}

const useStyles2 = makeStyles()((theme) => changePasswordOrPinPageStyle(theme));

export default function BudgetPage(props) {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  }, []);

  const context = useContext(Context);

  const { classes } = useStyles();
  const { classes: classes2, cx } = useStyles2();
  const [page, setPage] = React.useState(1);

  const token = sessionStorage.getItem("access_token");

  return (
    <Box component="div" sx={{ backgroundColor: primaryColor[14] }}>
      <HeaderSectionLoggedID
        page="changePassword"
        title="Change Password or pin"
      ></HeaderSectionLoggedID>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <main
            className={cx(classes2.content, {
              [classes2.contentShift]: context.stateDrawer,
            })}
          >
            <ChangePasswordSection cred={props.cred}></ChangePasswordSection>
          </main>
        </GridItem>
      </GridContainer>
    </Box>
  );
}
